// extracted by mini-css-extract-plugin
export default {"container":"Cotizaciones_container__cB3-y"};